export default {
  setBlueInvoiceInfo (state, blueInvoiceInfo) {
    state.blueInvoiceInfo = blueInvoiceInfo
  },
  setNumInfo (state, num) {
    state.setPlateNumber = num
  },
  setItemInvoiceInfo (state, itemInvoiceInfo) {
    state.itemInvoiceInfo = itemInvoiceInfo
  },
  setBillInfo (state, itemBillInfo) {
    state.itemBillInfo = itemBillInfo
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice/mutations.js